const KEY = 'oauth2QueryBackup';

function readCookie(name) {
    try {
        const match = document.cookie.split('; ').find(row => row.startsWith(name + '='));
        if (!match) return null;
        const value = match.split('=')[1] || '';
        return value ? decodeURIComponent(value) : null;
    } catch (e) {
        return null;
    }
}

function writeCookie(name, value, maxAgeSeconds) {
    try {
        if (!value) {
            document.cookie = name + '=; Max-Age=0; Path=/; SameSite=Lax';
        } else {
            document.cookie = name + '=' + encodeURIComponent(value) + '; Max-Age=' + maxAgeSeconds + '; Path=/; SameSite=Lax';
        }
    } catch (e) {
        // ignore cookie errors
    }
}

export function saveOauth2QueryBackup(searchString) {
    // Accept an explicit search string (w/o leading '?') or read from location
    let backup = '';
    try {
        if (typeof searchString === 'string') {
            backup = searchString.replace(/^\?/, '');
        } else if (typeof window !== 'undefined' && window.location && window.location.search) {
            const search = window.location.search;
            if (search && search.length > 1) {
                backup = search.substring(1);
            }
        }

        if (backup) {
            try { sessionStorage.setItem(KEY, backup); } catch (e) { /* ignore */ }
            writeCookie(KEY, backup, 600); // 10 minutes
        }
    } catch (e) {
        // ignore
    }
}

export function takeOauth2QueryBackup() {
    // Returns an object with query params or null if not found.
    let backup = null;
    try {
        backup = sessionStorage.getItem(KEY);
    } catch (e) {
        // ignore
    }

    if (!backup) {
        backup = readCookie(KEY);
    }

    if (!backup) {
        return null;
    }

    // Cleanup both storages
    try { sessionStorage.removeItem(KEY); } catch (e) { /* ignore */ }
    writeCookie(KEY, '', 0); // delete

    // Parse into object
    const params = {};
    try {
        const usp = new URLSearchParams(backup);
        for (const [k, v] of usp.entries()) {
            params[k] = v;
        }
    } catch (e) {
        // If malformed, try a naive split as a fallback
        try {
            backup.split('&').forEach(pair => {
                if (!pair) return;
                const [k, v] = pair.split('=');
                if (k) params[decodeURIComponent(k)] = v ? decodeURIComponent(v) : '';
            });
        } catch (e2) { return null; }
    }

    return params;
}
